import styled from 'styled-components'

const BaseAnno = styled.div`
  position: absolute;
  font-family: var(--font-sans-serif);
  min-width: 200px;
  font-size: 18px;
  font-size: 14px;
  line-height: 1.2em;
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  letter-spacing: .2px;
  * {
    flex: 0 0 100%;
  }
`

const SmallBaseAnno = styled(BaseAnno)`
  font-size: 12px;
`

export const LeftBig = styled(BaseAnno)`
  text-align: left;
  justify-content: flex-start;
`

export const RightBig = styled(BaseAnno)`
  text-align: right;
  justify-content: flex-end;
`

export const CenterBig = styled(BaseAnno)`
  text-align: center;
  justify-content: center;
  transform: translateX(-50%);
`

export const RightSmall = styled(SmallBaseAnno)`
  text-align: right;
  justify-content: flex-end;
`

export const LeftSmall = styled(SmallBaseAnno)`
  text-align: left;
  justify-content: flex-start;
`
export const CenterSmall = styled(SmallBaseAnno)`
   text-align: center;
  justify-content: center;
  transform: translateX(-50%);
`
export const Circle = styled.div`
transform: translate(-50%,-50%);
  position: absolute;
  display: inline-block;
  width: 120px;
  height: 120px;
  border-radius: 75px;
  border:2px solid var(--red-main);
`
